<template>
  <div>
    <div class="data-title">接口列表</div>
    <el-collapse class="api-table" v-if="apiListData.length>0" v-model="activeNames" accordion>
      <el-collapse-item v-for="(item,index) in apiListData" :key="index" :name="item.interId">
        <template slot="title">
          <div class="sort-title">
            <span class="sort-title-name">{{item.interDesc}}</span>
          </div>
        </template>
        <div class="sort-child">
          <el-collapse v-model="activeNamesChild" accordion>
            <el-collapse-item v-for="(itemChild,indexChild) in item.items"  :class="{'postApi':itemChild.interType=='POST','postAndGetApi':itemChild.interType=='POST&GET'}" v-if="itemChild.interType" :key="indexChild" :name="itemChild.interId">
              <template slot="title">
                <div class="api-title" @click="apiDetails(itemChild)">
                  <span class="api-title-type">{{itemChild.interType.replace('&',' / ')}}</span>
                  <span class="api-title-address">{{itemChild.interDesc}}</span>
                  <span class="api-title-name">{{itemChild.interUrl}}</span>
                </div>
              </template>
              <div class="api-detail" v-if="itemChild.detail!=null">
                <div class="parameter-show-box" v-if="itemChild.detail.interfaceRequestList.length!=0">
                  <div class="lable-name marginTop">请求参数说明</div>
                  <el-table
                    :data="itemChild.detail.interfaceRequestList"
                    border
                    style="width: 70%">
                    <el-table-column
                      type="index"
                      align="center"
                      label="序号"
                      width="70">
                    </el-table-column>
                    <el-table-column
                      label="参数名"
                      prop="paramName"
                      min-width="20%">
                    </el-table-column>
                    <el-table-column
                      label="类型"
                      min-width="20%">
                       <template slot-scope="scope">
                        <el-tag v-if="scope.row.paramType=='String'" type="warning" size="medium">{{ scope.row.paramType }}</el-tag>
                        <el-tag v-else-if="scope.row.paramType=='Integer'" size="medium">{{ scope.row.paramType }}</el-tag>
                        <el-tag v-else-if="scope.row.paramType=='JSONArray'||scope.row.paramType=='JSONObject'" type="success" size="medium">{{ scope.row.paramType }}</el-tag>
                        <el-tag v-else-if="scope.row.paramType=='Boolean'" type="info" size="medium">{{ scope.row.paramType }}</el-tag>
                        <el-tag v-else type="danger" size="medium">{{ scope.row.paramType }}</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="isRequired"
                      label="必填"
                      min-width="10%">
                    </el-table-column>
                    <el-table-column
                      prop="paramDescription"
                      label="描述"
                      min-width="50%">
                      <template slot-scope="scope">
                        <div v-html="scope.row.paramDescription"></div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <p class="tishi-p" v-if="itemChild.interType.replace('&',' / ')=='POST / GET' || itemChild.interType.replace('&',' / ')=='POST'"><span class="red">*</span><span class="boldStr">Parameter content type:</span>application/json</p>
                </div>
                <div class="resultInstance-box">
                  <div class="lable-name marginTop">请求结果示例</div>
                  <el-tabs v-model="activeNameTab">
                    <el-tab-pane v-for="(itemThird,indexThird) in itemChild.detail.interfaceSwaggerList" :key="indexThird" label="唯一示例" v-if="itemThird.type==0" :name="indexThird+'a'">
                      <json-viewer
                        class="pre-box resultInstance"
                        :value="itemThird.responseDemo"
                        :expand-depth=1
                        copyable
                        boxed
                        sort>
                      </json-viewer>
                    </el-tab-pane>
                    <el-tab-pane v-for="(itemThird,indexThird) in itemChild.detail.interfaceSwaggerList" :key="indexThird" :label="itemThird.type" v-if="itemThird.type!=0" :name="indexThird+'a'">
                      <json-viewer
                        class="pre-box resultInstance"
                        :value="itemThird.responseDemo"
                        :expand-depth=1
                        copyable
                        boxed
                        sort>
                      </json-viewer>
                    </el-tab-pane>
                  </el-tabs>
                  <div class="lable-name marginTop">请求结果说明</div>
                  <div class="result-explain">
                    <el-table
                      :data="itemChild.detail.interfaceResponseList"
                      border
                      style="width: 90%"
                      max-height="500"
                      :row-class-name="tableRowClassName">
                      <el-table-column
                        type="index"
                        align="center"
                        label="序号"
                        width="70">
                      </el-table-column>
                      <el-table-column
                        label="字段名"
                        prop="paramName"
                        min-width="30%">
                      </el-table-column>
                      <el-table-column
                        label="类型"
                        min-width="20%">
                        <template slot-scope="scope">
                          <el-tag v-if="scope.row.paramType=='String'" type="warning" size="medium">{{ scope.row.paramType }}</el-tag>
                          <el-tag v-else-if="scope.row.paramType=='Integer'" size="medium">{{ scope.row.paramType }}</el-tag>
                          <el-tag v-else-if="scope.row.paramType=='JSONArray'||scope.row.paramType=='JSONObject'" type="success" size="medium">{{ scope.row.paramType }}</el-tag>
                          <el-tag v-else-if="scope.row.paramType=='Boolean'" type="info" size="medium">{{ scope.row.paramType }}</el-tag>
                          <el-tag v-else type="danger" size="medium">{{ scope.row.paramType }}</el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="描述"
                        min-width="50%">
                        <template slot-scope="scope">
                          <div v-html="scope.row.paramDescription"></div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <div class="parameter-box">
                  <div class="lable-name marginTop">请求参数测试</div>
                  <el-table
                    :data="itemChild.detail.interfaceRequestList"
                    border
                    style="width: 60%">
                    <el-table-column
                      label="接口参数名"
                      prop="paramName"
                      min-width="20%">
                    </el-table-column>
                    <el-table-column
                      label="接口参数类型"
                      min-width="20%">
                      <template slot-scope="scope">
                        <el-tag v-if="scope.row.paramType=='String'" type="warning" size="medium">{{ scope.row.paramType }}</el-tag>
                        <el-tag v-else-if="scope.row.paramType=='Integer'" size="medium">{{ scope.row.paramType }}</el-tag>
                        <el-tag v-else-if="scope.row.paramType=='JSONArray'||scope.row.paramType=='JSONObject'" type="success" size="medium">{{ scope.row.paramType }}</el-tag>
                        <el-tag v-else-if="scope.row.paramType=='Boolean'" type="info" size="medium">{{ scope.row.paramType }}</el-tag>
                        <el-tag v-else type="danger" size="medium">{{ scope.row.paramType }}</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="center"
                      label="必填"
                      min-width="10%">
                      <template slot-scope="scope">
                        <div class="checkbox-box">
                          <el-checkbox v-if="scope.row.isRequired=='是'" :checked="true"></el-checkbox>
                          <el-checkbox v-if="scope.row.isRequired!='是'"></el-checkbox>
                          <span class="checkbox-hide"></span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="center"
                      label="接口输入值"
                      min-width="50%">
                      <template slot-scope="scope">
                        <el-upload
                          v-if="scope.row.paramType=='File' || scope.row.paramType=='MultipartFile'"
                          class="upload-demo"
                          ref="upload"
                          action="doUpload"
                          :limit="1"
                          :before-upload="beforeUpload">
                          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                          <a v-if="itemChild.interId=='B0413'" href="http://47.104.249.102:8188/financial/report/riskinfo/downLoad"><el-button size="small" type="success">下载模板</el-button></a>
                          <div slot="tip" class="el-upload__tip">只能上传excel文件，且不超过5MB</div>
                          <div slot="tip" class="el-upload-list__item-name">{{files.name}}</div>
                        </el-upload> 
                        <el-input v-if="scope.row.paramType!='File' && scope.row.paramType!='MultipartFile'" v-model="scope.row.value" placeholder="请输入内容"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button class="marginTop" style="margin-top:20px!important;" type="primary" @click="sureFun(itemChild.detail.interUrl,itemChild.detail.interfaceRequestList,itemChild.detail.interType,itemChild.detail.interRemark)">确 定</el-button>
                </div>
                <div class="request-result" v-show="itemChild.detail.responseResult!=''">
                  <div class="lable-name marginTop">请求返回结果</div>
                  <json-viewer
                    class="pre-box resultInstance"
                    :value="itemChild.detail.responseResult"
                    :expand-depth=1
                    copyable
                    boxed
                    sort>
                  </json-viewer>
                </div> 
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      activeNames: '',
      activeNamesChild: '',
      apiListData:[],
      activeNameTab:'0a',
      userInfo:JSON.parse(localStorage.getItem('UserInfo')),
      files:{}
    }
  },
  mounted () {
    var _this=this;
    _this.getApiDataList();
  },
  methods:{
    tableRowClassName({row, rowIndex}) {
      if (row.paramName.indexOf('type:') != -1) {
        return 'warning-row';
      }
      return '';
    },

    apiDetails: function(apiInfo){
      var _this=this;
      _this.$axios.post('/requestApi/data/find/findInterfaceByInterId?interId='+apiInfo.interId)      
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){
            _this.files=new Object();
            _this.apiListData.forEach(function(item){
              item.items.forEach(function(itemSecond){
                if(itemSecond.interId==apiInfo.interId){
                  itemSecond.detail=data.data;
                  itemSecond.detail.interfaceSwaggerList.forEach(function(itemThird){
                    itemThird.responseDemo=JSON.parse(itemThird.responseDemo,null,2);
                  });
                  return false;
                }
              });
            });
            _this.$forceUpdate();
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
    },
    // 获取接口数据
    getApiDataList:function(){
      var _this=this;
      _this.$axios.post('/requestApi/manage/findInterfaceList')      
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){
            _this.apiListData=data.data;
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
    },
    sureFun: function(apiStr,apiSend,apiType,tag){
      var _this=this;
      // console.log("apiStr=============="+apiStr);
      // console.log("apiSend=============="+JSON.stringify(apiSend));
      // console.log("apiType=============="+apiType);
      // console.log("tag======"+tag);
      // console.log("------------------------------------------------------------");
      var  AllowRequest=true;
      apiSend.forEach(function(item){
        if(item.isRequired=='是' && item.value==''){
          _this.$message('请检查参数');
          AllowRequest=false;
          return false;
        }
      });
      if(AllowRequest){
        var loading = this.$loading({
          lock: true,
          text: '请求中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var url='/api'+apiStr;
        var sendData=new Object();
        apiSend.forEach(function(item){
          sendData[item.paramName]=item.value;
        });
        // _this.userInfo.userToken
        if(apiType=='POST'){
          if(Number(tag)==1){
            var hasRequest=false;
            var apiSendLength=0;
            apiSend.forEach(function(item,index){
              if(item.value!=''){
                apiSendLength=index;
                hasRequest=true;
                return
              };
            });
            if(hasRequest){
              url = url + "?";
            };
            var ziduanArr=[];
            apiSend.forEach(function(item,index){
              ziduanArr.push(item.paramName);
              if(item.value!=''){
                if(index!=apiSendLength){
                  url = url + item.paramName + "=" + item.value + "&";
                }else{
                  url = url + item.paramName + "=" + item.value;
                }
              }
            });
            var fileType='file';
            if(ziduanArr.indexOf('image')>-1){
              fileType='image';
            };
            var fileFormData = new FormData();
            if(_this.files.name!=undefined){
              fileFormData.append(fileType, _this.files, _this.files.name);//filename是键，file是值，就是要传的文件，test.zip是要传的文件名
            };
            // fileFormData.append('file', _this.files, _this.files.name);
            var requestConfig = {
              headers: {
                "apikey":_this.userInfo.userToken,  //token换成从缓存获取
                'Content-Type': 'multipart/form-data'
              },
            };
            // console.log("url--------"+url);
            // console.log(fileFormData);
            // console.log("-------------------------------------");
            _this.$axios.post(url,fileFormData,requestConfig)      
              .then(function(response){
                loading.close();
                let data = response.data;
                var returnStr=data;
                _this.apiListData.forEach(function(item){
                  item.items.forEach(function(itemSecond){
                    if(itemSecond.interUrl==apiStr){
                      itemSecond.detail.responseResult=returnStr;
                    }
                  });
                });
                _this.$forceUpdate();
              })
              .catch(function(error){
                // console.log(error)
                loading.close();
                var returnStr=error;
                _this.apiListData.forEach(function(item){
                  item.items.forEach(function(itemSecond){
                    if(itemSecond.interUrl==apiStr){
                      itemSecond.detail.responseResult=returnStr;
                    }
                  });
                });
                _this.$forceUpdate();
              });
          }else{
            _this.$axios.post(url,sendData,{headers: {
                "apikey":_this.userInfo.userToken  //token换成从缓存获取
              }})      
              .then(function(response){
                loading.close();
                let data = response.data;
                var returnStr=data;
                _this.apiListData.forEach(function(item){
                  item.items.forEach(function(itemSecond){
                  if(itemSecond.interUrl==apiStr){
                      itemSecond.detail.responseResult=returnStr;
                    }
                  });
                });
                if(Number(tag)==2 && data.status==200){
                    window.open(data.data.reportURL);
                };
                _this.$forceUpdate();
              })
              .catch(function(error){
                loading.close();
                // console.log(error)
                var returnStr=error;
                _this.apiListData.forEach(function(item){
                  item.items.forEach(function(itemSecond){
                    if(itemSecond.interUrl==apiStr){
                      itemSecond.detail.responseResult=returnStr;
                    }
                  });
                });
                _this.$forceUpdate();
              });
          }
        }else{
          var hasRequest=false;
          var apiSendLength=0;
          apiSend.forEach(function(item,index){
            if(item.value!=''){
              apiSendLength=index;
              hasRequest=true;
              return
            };
          });
          if(hasRequest){
            url = url + "?";
          };
          apiSend.forEach(function(item,index){
            if(item.value!=''){
              if(index!=apiSendLength){
                url = url + item.paramName + "=" + item.value + "&";
              }else{
                url = url + item.paramName + "=" + item.value;
              }
            }
          });
          _this.$axios.get(url,{headers: {
            "apikey":_this.userInfo.userToken  //token换成从缓存获取
          }})      
            .then(function(response){
              loading.close();
              let data = response.data;
              // console.log("----------"+JSON.stringify(data));
              // console.log("tag----------"+tag);
              var returnStr=data;
              _this.apiListData.forEach(function(item){
                item.items.forEach(function(itemSecond){
                  if(itemSecond.interUrl==apiStr){
                    itemSecond.detail.responseResult=returnStr;
                  }
                });
              });
              if(Number(tag)==2 && data.status==200){
                  window.open(data.data.reportURL);
              };
              _this.$forceUpdate();
            })
            .catch(function(error){
              loading.close();
              // console.log(error)
              var returnStr=error;
              _this.apiListData.forEach(function(item){
                item.items.forEach(function(itemSecond){
                  if(itemSecond.interUrl==apiStr){
                    itemSecond.detail.responseResult=returnStr;
                  }
                });
              });
              _this.$forceUpdate();
            });
        }
        // console.log("可以请求");
      }else{
        // console.log("不能请求");
      };
    },
    beforeUpload(file){
      this.files = file;
      // const extension = file.name.split('.')[1] === 'xls'
      // const extension2 = file.name.split('.')[1] === 'xlsx'
      const isLt2M = file.size / 1024 / 1024 < 5
      // if (!extension && !extension2) {
      // this.$message.warning('上传模板只能是 xls、xlsx格式!')
      // return
      // }
      if (!isLt2M) {
      this.$message.warning('上传文件大小不能超过 5MB!')
      return
      }
      return false // 返回false不会自动上传
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .sort-title{width: 97%;}
  
  .data-title{margin-bottom: 12px;}
  .sort-title span{display: inline-block; font-size: 16px; line-height: 48px; color: #333;}
  .is-active .sort-title span{color: #2855f7;}

  .api-title{width: 97%;}
  .api-title span{display: inline-block; font-size: 16px; line-height: 48px; color: #333;}
  .get{background-color: #0f6ab4;}
  .post{background-color: #10a54a;}
  .el-collapse-item__content .el-collapse-item{background-color: rgba(15,106,180,0.2)!important;}
  .el-collapse-item__content .postApi{background-color: rgba(16,165,74,0.2)!important;}
  .el-collapse-item__content .postAndGetApi{background-color: rgba(211,128,66,0.2)!important;}
  .api-title .api-title-type{background-color: #0f6ab4;padding: 0px 15px; text-align: center;color: #fff; border-radius: 3px;}
  .postApi .api-title .api-title-type{background-color: #10a54a;}
  .postAndGetApi .api-title .api-title-type{background-color: #d38042;}
  .api-title-address{text-indent: 6px;}
  .api-title .api-title-name{float: right;}
  .lable-name{font-size: 15px; line-height: 60px;font-weight: bold;color: #000;}
  .lable-name-second{font-size: 16px; line-height: 40px;color: #333;}
  .api-detail{padding: 10px 20px;border: 1px solid #EBEEF5;}
  .pre-box{background-color: #fcf6db; border: 1px solid #e5e0c6; cursor: pointer; overflow:auto;padding: 10px 20px;}
  .checkbox-box{position: relative;}
  .checkbox-hide{display: block;width: 100%;height: 100%; position: absolute;top:0px;left: 0px;z-index: 20;}
  .el-checkbox{margin-right: 0px;}
  .api-table>.el-collapse-item:hover{background-color: #e0eeff;}
  .api-table>.el-collapse-item .sort-title span{text-indent: 10px;}
</style>



// WEBPACK FOOTER //
// src/components/DataServiceManagementSuper.vue